import React, { useEffect } from "react";
import goldenLogo from "../../../assets/logos/golden-logo.svg";
import whiteLogo from "../../../assets/logos/white-logo.png";
import styles from "./Loader.module.scss";
import { useSelector } from "react-redux";

const Loader = ({ state }) => {
  const { loading } = useSelector((state) => state.loading);
  useEffect(() => {
    document.body.style.overflow = loading ? "hidden" : "visible";
  }, [loading]);
  if (loading || state) {
    return (
      <>
        <span className={styles.loader}>
          <img src={whiteLogo} alt="white-logo" />
          <img className={styles.blink} src={goldenLogo} alt="golden-logo" />
        </span>
      </>
    );
  } else {
    return null;
  }
};

export default Loader;
